import React, { useState, useRef } from 'react';
import { getEncUrlDhofar } from '../../actions/CCAvenueAction'
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import { salesforceSendFormNumber } from '../../actions/StudentAction';


const BankDhofar = ({paymentConfig,userDetail,selectedMethodFeeDetail,feeDetail}) => {
    const formRef = useRef(null);
    const navigate = useNavigate()
    const [loading,setLoading] = useState(false)
    const [encRequestRes, setEncRequestRes] = useState()
    const [formActionUrl,setFormActionUrl] = useState();

    const {form_num,id} = userDetail !==undefined && userDetail
    const {instData} = selectedMethodFeeDetail
    const {installment_type,net_payable_amount,scholarship_amount,scholarship_percentage,total_fee} = feeDetail !==undefined && feeDetail
    let accessCode = `${paymentConfig.access_code}`

    let order_no =new Date().getUTCMilliseconds();
    let orderWithFormNum=`${id}${order_no}${form_num}`

    const checkout = async () => {
        setLoading(true)
        const successUrl = `${process.env.REACT_APP_PUBLIC_URL}/student/paymentstatus/success`;
        const failureUrl = `${process.env.REACT_APP_PUBLIC_URL}/student/paymentstatus/failure`;
        const data = {
            student_id: id,
            amount:parseFloat(instData?.amount).toFixed(2) ,
            gateway_id: paymentConfig.id,
            order_id:orderWithFormNum,
            success_url:successUrl,
            failure_url:failureUrl,
            scholarship_amount:scholarship_amount,
            net_payable_amount:net_payable_amount,
            installments_id:instData?.installment_id,
            installment_type:instData?.installment_number ==0 ? "lumpsum" :installment_type,
            scholarship_percentage:scholarship_percentage,
            actual_inst_amt:parseFloat(instData?.amount).toFixed(2),
            course_fee:total_fee,
            installments_number:instData?.installment_number
          }
      

        try {
          const EncUrlRes = await getEncUrlDhofar(data)
          if (EncUrlRes.encrypted_data !== undefined) {
              setLoading(true)
              salesforceSendFormNumber({form_num:form_num,status:'payment_initiated'})
              setEncRequestRes(EncUrlRes?.encrypted_data);
              setFormActionUrl(EncUrlRes?.dhofar_url)
              setTimeout(() => { formRef.current.submit(); }, 1000)
          }
          else {
              swal(`Payment Failed! We couldn't process your payment. Please Try Again
                  Don't worry your money is safe! If amount was debited from your account, it will be refunded automatically in 5-7 working days`, '', 'error');
              setLoading(false)
          }
          
        } catch (error) {
          console.log('bank dhofar error...',error)
        }
        
            
    }
   
    return (
        <React.Fragment>
            <div>
            {loading ? <button type="submit" disabled className="banktransfer_btn">
                    <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                    Processing ...</button> : 
               <button onClick={checkout} className='banktransfer_btn'>Online payment/CC/DC</button>
            }
                
                <form ref={formRef}
                    method="POST"
                    name="redirect"
                    action={formActionUrl !==undefined ? formActionUrl : ''}
                    >
                    <input type="hidden" id="encRequest" name="enc_request" value={encRequestRes} />
                    <input type="hidden" name="access_code" id="access_code" value={accessCode} />
                </form>
            </div>

        </React.Fragment>
    )
}

export default BankDhofar